export const mapAndTransformSpecialtyString = specialtyString => {
	const specialtyType = specialtyString
		.split('-')
		.map(word => {
			if (word.toLowerCase() === 'and') {
				return 'and';
			}
			return word.charAt(0).toUpperCase() + word.slice(1);
		})
		.join(' ');

	return {
		transformedString: specialtyType,
	};
};
